<template>
  <q-page class="q-pa-md column page-linear">
    <div class="q-mt-xl"></div>
    <img
      class="self-center q-mt-xl"
      src="../assets/Maintenance.svg"
      alt="Under Maintenance"
    />
    <div class="self-center text-h5 text-center">
      {{t('maintenance.text')}}
    </div>
  </q-page>
</template>
<script>
import { useI18n } from 'vue-i18n';

export default {
  name: "Maintenance",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: 'local'
    });
    return {t}
  }
};
</script>
<style>
.page-linear {
  background: linear-gradient(-45deg,rgb(96, 156, 96),rgb(88, 200, 84));
}
</style>